import { Builder } from '@builder.io/sdk';
import { HelpCentreList } from './HelpCentreList';
import { HELP_CENTRE_LIST_NAME } from './HelpCentreList.types';

const HelpCentreListConfig = {
  name: HELP_CENTRE_LIST_NAME,
  friendlyName: 'Help Centre List',
  inputs: [
    {
      name: 'title',
      type: 'string',
      defaultValue: 'Help Centre',
    },
  ],
};

Builder.registerComponent(HelpCentreList, HelpCentreListConfig);
